import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Stack, Alert, Box,CircularProgress } from '@mui/material';
import preCampagnaApi from '../../api/preCampagnaApi';
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};
export default function CrowdfundingPreCampagnaPage() {
  const [formData, setFormData] = useState({ nome: '', cognome:'', email: '',telefono:'' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      await preCampagnaApi.register(formData);
      setSuccess(true);
      setFormData({ nome: '', email: '' });
    } catch (err) {
      console.error(extractErrorMessage(err));
      setError(extractErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
          {loading && (
            <Box
              sx={{
                position: 'fixed',
                inset: 0,
                bgcolor: 'rgba(255,255,255,0.7)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1300,
              }}
            >
              <CircularProgress size={48}/>
            </Box>
          )}
      <Typography variant="h4" sx={{ mb: 2 }}>Partecipa alla pre-campagna crowdfunding</Typography>
      <Typography sx={{ mb: 3 }}>
        Inserisci i tuoi dati per ricevere aggiornamenti sul progetto e partecipare alla campagna in anteprima!
      </Typography>

      {success && <Alert severity="success" sx={{ mb: 2 }}>Registrazione avvenuta con successo!</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            label="Nome"
            name="nome"
            value={formData.nome}
            onChange={handleChange}
            required
            fullWidth
          />
            <TextField
              label="Cognome"
              name="cognome"
              value={formData.cognome}
              onChange={handleChange}
              required
              fullWidth
            />
          <TextField
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
            fullWidth
          />
          <Button type="submit" variant="contained" disabled={loading} fullWidth>
            Iscriviti
          </Button>
        </Stack>
      </form>

      <Typography sx={{ mt: 3, fontSize: 14 }}>
        I tuoi dati saranno utilizzati esclusivamente per ricevere aggiornamenti sulla campagna. Non condivideremo mai le tue informazioni.
      </Typography>
    </Container>
  );
}